export const Checkbox = {
  baseStyle: {
    control: {
      borderRadius: "2px",
      borderColor: "grey.800",
    },
    label: {
      marginLeft: "s200",
    },
  },
};
